import './setPublicPath';

import 'react-app-polyfill/ie11';
import React from 'react';
import ReactDOM from 'react-dom';
import { root } from 'baobab-react/higher-order';

import App from './App/App';
import store from './store';

import './styles/common.css';
import './index.css';

const RootedApp = root(store, App);

class BrownField {
  constructor(el) {
    this.container = el;

    ReactDOM.render(<RootedApp />, el);
  }

  remove() {
    ReactDOM.unmountComponentAtNode(this.container);
  }
}

export default BrownField;
